import {
  HomeIntro,
  StatementBand,
  ArchTiles,
  MaeTerraFeature,
  ImageWall,
} from "@/components/HomeSections";

/**
 * Home, third pass, and this one takes the client's reference literally.
 *
 * She sent justinablakeney.com twice and said she was not convinced by the
 * hub. Measured on the live reference, its recipe is: her face and name with a
 * one sentence bio, a quote band in a warm solid, small arch topped category
 * tiles in one row, one feature block, then a wall of imagery with almost no
 * copy. Reading is optional below the bio.
 *
 * So that is exactly this page: Shruthi first, one true line in a band, five
 * arch doors, one bookable feature, and her work as a wall.
 */
export default function Home() {
  return (
    <main className="bg-cream text-ink no-x" data-testid="home-page">
      <HomeIntro />
      <StatementBand />
      <ArchTiles />
      <MaeTerraFeature />
      <ImageWall />
    </main>
  );
}
